<div class="modal-header">
    <h4 class="modal-title">Çevre Şartı Ekle</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body col-12">
    <form #environmentalConditionForm="ngForm" (ngSubmit)="saveEnvironmentalConditions()">

        <!-- Dinamik çevre şartı ekleme alanları -->
        <div *ngFor="let condition of environmentalConditions; let i = index" class="form-group row">
            <div class="col-xl-4">
                <label for="name-{{i}}">Adı:</label>
                <input type="text" class="form-control" [(ngModel)]="condition.name" name="name-{{i}}" placeholder="Adı"
                    required />
            </div>

            <div class="col-xl-3">
                <label for="start-{{i}}">Başlangıç</label>
                <input type="text" class="form-control" [(ngModel)]="condition.start" name="start-{{i}}"
                    placeholder="Başlangıç Değeri" required />
            </div>

            <div class="col-xl-3">
                <label for="end-{{i}}">Bitiş:</label>
                <input type="text" class="form-control" [(ngModel)]="condition.end" name="end-{{i}}"
                    placeholder="Bitiş Değeri" required />
            </div>
            <div class="col-xl-1 mt-2">
                <button type="button" class="btn btn-danger" (click)="removeEnvironmentalCondition(i)">-</button>
            </div>
        </div>

        <!-- Yeni çevre şartı ekleme butonu -->
        <button type="button" class="btn btn-success" (click)="addEnvironmentalCondition()">+</button>



        <!-- Kaydet ve İptal butonları -->
        <div class="mt-2 d-flex justify-content-between align-items-center">
            <div class="w-50">
                <ng-select [items]="kinds" name="selectedType" bindLabel="typeName" bindValue="id" [(ngModel)]="selectedType"
                    placeholder="Tür Seçin"></ng-select>
            </div>
            <div>
                <button type="button" class="btn btn-danger mr-1" (click)="closeModal()">İptal</button>
                <button type="submit" class="btn btn-primary"
                    [disabled]="!environmentalConditionForm.valid || !selectedType">Kaydet</button>
            </div>
        </div>

    </form>
</div>